module.exports = __webpack_public_path__ + "media/images/common/lp/icon-mail-11c6f626d8d9c33177bd2790b6573197.png";